import React from 'react'
import { Accordion, Image } from '@sainsburys-tech/bolt'
import { isEmpty } from '@sainsburys-tech/boltui-utils'
import { withCookies } from 'react-cookie'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { scrollToAccordion } from '../../helpers/openAccordion'
import { isArgosTestVariant } from '../../helpers/abTestHelper.js'
import * as Styled from './EnergyLabelAccordion.styles'

const EnergyFields = ({ energy }) => {
  if (isEmpty(energy)) return null
  return (
    <>
      {energy && <p>Energy efficiency information:</p>}
      {Object.values(energy).map((field, index) => {
        return (
          field && (
            <li key={`energy-field-${index}`}>
              {field?.title}: {field?.value} {field?.unit}
            </li>
          )
        )
      })}
    </>
  )
}

const EnergyLabelAccordion = energyOptions => {
  const { onAccordionChange, energyLabelContent, attributes = {}, allCookies } = energyOptions
  const isAvifTestVariant = isArgosTestVariant(allCookies)
  const dataTest = 'energy-rating-accordion'
  const EnergyHeader = <Styled.Heading> Energy Ratings </Styled.Heading>
  const onAccordionInteraction = (index, show) => {
    onAccordionChange('energy', show)
    if (show) scrollToAccordion('#energy-rating')

    // Adobe Analytics Tracking Code
    const adobeAnalytics = show ? pushEventAndTrack : () => {}
    adobeAnalytics({
      eventInfo: {
        eventName: 'pdp_showMore',
        eventAction: 'Energy Ratings'
      }
    })
  }

  const accordionOptions = {
    title: EnergyHeader,
    onClick: onAccordionInteraction,
    name: 'energy',
    id: 'energy-rating',
    'data-test': dataTest,
    index: dataTest
  }

  return (
    <Accordion.Item as='h3' hasBorderBottom noAnimation {...accordionOptions}>
      <Styled.EnergyContentWrapper data-test='energy-data'>
        <EnergyFields energy={attributes} />
      </Styled.EnergyContentWrapper>
      <Styled.Wrapper>
        {energyLabelContent.map((image, index) => (
          <Image
            src={image}
            alt='Energy label'
            width='440'
            height='440'
            quality='70'
            lazy
            key={index}
            avifIsEnabled={isAvifTestVariant}
          />
        ))}
      </Styled.Wrapper>
    </Accordion.Item>
  )
}

export { EnergyLabelAccordion }
export default withCookies(EnergyLabelAccordion)
